import styles from './Preloaderrow.module.css'
import { TableCell, TableRow } from '@material-ui/core';

export const PreloaderRow = () => {
  return (
   
    // <TableRow style={{ width: '100%', textAlign: 'center' }} hover>
    //   <TableCell colSpan={4} align="center" >
        <div className={styles.container}>
          <div className={styles.preloader}>
            <div className={styles.dots}>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
              <div className={styles.dot}></div>
            </div>
          </div>
        </div>
    //   </TableCell>
    // </TableRow>
 
  )
}